var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 7,
    viewBox: "0 0 44 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get it on"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.63354 3.71575C7.63354 4.63755 7.36074 5.37125 6.81404 5.91905C6.19364 6.57025 5.38404 6.89585 4.38964 6.89585C3.43704 6.89585 2.62634 6.56585 1.96084 5.90585C1.29424 5.24475 0.960938 4.42635 0.960938 3.44955C0.960938 2.47165 1.29424 1.65325 1.96084 0.993248C2.62634 0.332148 3.43704 0.00214933 4.38964 0.00214933C4.86264 0.00214933 5.31474 0.0945487 5.74374 0.278249C6.17384 0.463049 6.51814 0.708349 6.77554 1.01525L6.19584 1.59605C5.75914 1.07355 5.15743 0.812849 4.38853 0.812849C3.69333 0.812849 3.09273 1.05705 2.58563 1.54545C2.07853 2.03385 1.82554 2.66855 1.82554 3.44845C1.82554 4.22835 2.07853 4.86305 2.58563 5.35145C3.09273 5.83985 3.69333 6.08405 4.38853 6.08405C5.12553 6.08405 5.74044 5.83875 6.23214 5.34705C6.55114 5.02695 6.73594 4.58145 6.78544 4.01055H4.38853V3.21745H7.58624C7.61924 3.39015 7.63354 3.55625 7.63354 3.71575Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7046 0.95921H9.69944V3.05141H12.4098V3.84451H9.69944V5.93671H12.7046V6.74851H8.85134V0.148511H12.7046V0.95921Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2806 6.74851H15.4325V0.95921H13.5889V0.148511H18.1242V0.95921H16.2806V6.74851Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4055 6.74851V0.148511H22.2536V6.74851H21.4055Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0146 6.74851H25.1665V0.95921H23.3229V0.148511H27.8582V0.95921H26.0146V6.74851Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4435 5.896C35.7945 6.5626 34.9882 6.8959 34.0235 6.8959C33.0588 6.8959 32.2525 6.5626 31.6046 5.896C30.9556 5.2294 30.6322 4.4132 30.6322 3.4485C30.6322 2.4838 30.9556 1.6676 31.6046 1.001C32.2525 0.3344 33.0588 0 34.0235 0C34.9827 0 35.7879 0.335499 36.4391 1.0054C37.0903 1.6753 37.4159 2.4893 37.4159 3.4485C37.4159 4.4132 37.0914 5.2294 36.4435 5.896ZM32.2305 5.3427C32.7189 5.8377 33.3162 6.0841 34.0235 6.0841C34.7308 6.0841 35.3292 5.8366 35.8165 5.3427C36.3049 4.8477 36.5502 4.2163 36.5502 3.4485C36.5502 2.6807 36.3049 2.0493 35.8165 1.5543C35.3292 1.0593 34.7308 0.8129 34.0235 0.8129C33.3162 0.8129 32.7189 1.0604 32.2305 1.5543C31.7432 2.0493 31.4979 2.6807 31.4979 3.4485C31.4979 4.2163 31.7432 4.8477 32.2305 5.3427Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6061 6.74851V0.148511H39.6379L42.8455 5.28221H42.8818L42.8455 4.01061V0.148511H43.6936V6.74851H42.8081L39.452 1.36511H39.4157L39.452 2.63671V6.74851H38.6061Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGet1);
export default __webpack_public_path__ + "static/media/get1.30556e6b73caaf2709e39c16bc53e3c2.svg";
export { ForwardRef as ReactComponent };